import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLayers } from '../../../../slice/selectors';
import { ILayer } from '../../../../slice/types';
import { useTranslation } from 'react-i18next';
import { useMapSlice } from '../../../../slice';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';

import DraggableLayerItem from './DraggableLayerItem';
import MapMenu from 'app/components/MapMenu/MapMenu';

interface IProps {}

const LayersMenu: FC<IProps> = () => {
  const { t } = useTranslation();

  const { actions } = useMapSlice();
  const dispatch = useDispatch();

  const layers = useSelector(selectLayers);

  const [sliderVisibleLayersIdArr, setSliderVisibleLayersIdArr] = useState<
    string[]
  >([]);

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    dispatch(
      actions.reorderLayers({
        startIndex: result.source.index,
        endIndex: result.destination.index,
      }),
    );
  };

  const onCheckboxClick = (layerId: string) => () => {
    dispatch(actions.toggleLayer({ layerId }));
  };

  const onOpacityChange = (layerId: string) => (opacityValue: number) => {
    dispatch(
      actions.setLayerOpacity({
        layerId,
        opacity: opacityValue / 100,
      }),
    );
  };

  const onEyeClick = (layerId: string) => () => {
    setSliderVisibleLayersIdArr(prevState => {
      if (prevState.includes(layerId)) {
        return prevState.filter(id => layerId !== id);
      } else {
        return [...prevState, layerId];
      }
    });
  };

  return (
    <MapMenu title={t('Map.Layers', 'Layers')}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="list">
          {provided => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {layers.map((layer: ILayer, index) => (
                <DraggableLayerItem
                  isSliderVisible={sliderVisibleLayersIdArr.includes(layer.id)}
                  index={index}
                  key={layer.id}
                  layer={layer}
                  onEyeClick={onEyeClick(layer.id)}
                  onCheckboxClick={onCheckboxClick(layer.id)}
                  onOpacityChange={onOpacityChange(layer.id)}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </MapMenu>
  );
};

export default LayersMenu;
